import React from "react";
import Home from "./home";
import "regenerator-runtime/runtime";

const WalletShareAnalytics = () => <Home />;

export default WalletShareAnalytics;
